import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark } from '@fortawesome/free-solid-svg-icons'

import './style.scss';

const BookmarkButton = props => {
    return (
        <div
            className="bookmark-button__container"
            role="button"
            tabIndex="0"
            aria-label={props.active ? 'Remove bookmark' : 'Bookmark this property'}
            aria-pressed={!!props.active}
            onClick={props.onBookmark}
        >
            <FontAwesomeIcon 
                className={`bookmark-button__icon_${props.active ? "active" : "inactive"}`}
                icon={faBookmark}
                size="lg"
            />
            { props.text && (<span className="ms-2">{props.active ? props.activeText || props.text : props.text}</span>) }
        </div>
    )
}

export default BookmarkButton;